import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import PhotoTile from './PhotoTile';

interface DraggablePhotoTileProps {
  photoId: string;
  photoUrl: string;
  isSelected: boolean;
  isRepresentative: boolean;
  onClick: (photoId: string, event: React.MouseEvent) => void;
  stackCount?: number;
  onStackClick?: (photoId: string) => void;
  isDraggedAway: boolean;
}

const DraggablePhotoTile: React.FC<DraggablePhotoTileProps> = ({
  photoId,
  photoUrl,
  isSelected,
  isRepresentative,
  onClick,
  stackCount,
  onStackClick,
  isDraggedAway,
}) => {
  const { attributes, listeners, setNodeRef } = useDraggable({ id: photoId });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      data-photo-id={photoId}
      style={{ opacity: isDraggedAway ? 0.4 : 1, transition: 'opacity 0.15s' }}
    >
      <PhotoTile
        photoId={photoId}
        photoUrl={photoUrl}
        isSelected={isSelected}
        isRepresentative={isRepresentative}
        onClick={onClick}
        stackCount={stackCount}
        onStackClick={onStackClick}
      />
    </div>
  );
};

export default DraggablePhotoTile;
